import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  clockIconParent: {
    textAlign: "center",
  },
  modalHeading: {
    textAlign: "center",
    margin: "5px 0",
    textTransform: "capitalize",
    fontWeight: "500",
  },
  cancelBtn: {
    backgroundColor: "transparent",
    color: "#000000",
    border: "1px solid #D0D5DD",
    width: "47%",
    transition: "0.3s",
    "&:hover": {
      backgroundColor: "#000000",
      color: "#ffffff",
    },
  },
  action: {
    textTransform: "capitalize",
    backgroundColor: "var(--app-primary)",
    color: "var(--app-on-primary)",
    width: "47%",
    transition: "0.3s",
    "&:hover": {
      backgroundColor: "#000000",
    },
  },
  warn: {
    textAlign: "center",
    color: "#737373",
    fontSize: "small",
    width: "80%",
    margin: "0 auto",
  },
}));

export default useStyles;
